export default {
  failed_to_open: 'Não foi possível abrir o onboarding para este restaurante. Por favor, tente novamente.',
};
